<template>
	<resource-list-item :image="thumbnail" :to="toLink"
						:replace="props.replaceHistory ?? false"
						divided
						:image-ratio="3/2"
						:image-width="!props.smallThumbnail && $breakpoint.smAndUp ? 160 : 64"
						:title="props.title ?? props.job.title"
						:subtitle="props.subtitle ?? (props.job.event ? props.job.event.display_name : props.job.club?.display_name)"
						:description="props.job.short_description">

		<info-list class="mt-8" small>

			<info-list-item v-if="props.job.has_active_waiting_list" color="warning" :text="$t('label.waiting_list')"/>
			<info-list-item v-else-if="![undefined, null].includes(props.job.open_positions_count)" :color="props.job.open_positions_count < 5 ? 'warning' : 'success'"
							:text="$t('param_label.open_positions', props.job.open_positions_count, {count: props.job.open_positions_count})"/>

			<info-list-item v-if="props.job.start_date || props.job.end_date" :icon="icons.date">
				<dynamic-date-range :start="props.job.start_date" :end="props.job.end_date" specific-time/>
			</info-list-item>

			<info-list-item v-if="props.job.coarse_address || props.job.is_remote" :icon="icons.location">
				<div class="flex flex-column">
					<span>{{ props.job.coarse_address ?? $t('label.remote') }}</span>
					<span v-if="props.job.distance" class="text-gray-400 text-3xs">{{ $t('label.distance_km', {distance: Math.ceil((props.job.distance / 1000))}) }}</span>
				</div>
			</info-list-item>

		</info-list>

		<template v-if="toLink || $slots.right" #right>
			<slot name="right"/>
			<Icon v-if="toLink" :icon="icons.next" color="gray-400" class="block"/>
		</template>

	</resource-list-item>
</template>

<script setup lang="ts">
import {getEventAvatarThumbnail} from "@spoferan/spoferan-ts-core";
import type {JobPreview} from "@spoferan/spoferan-ts-core";
import {mdiCalendarRange, mdiMapMarkerOutline} from "@mdi/js";
import {nextIcon} from "../../config";
import {computed} from 'vue';
import {useNuxtApp} from '#app';

const {$spoferanUrl} = useNuxtApp();

const props = defineProps<{
	job: JobPreview, // A job, job posting, or application
	smallThumbnail?: boolean,
	to?: string | object,
	replaceHistory?: boolean,

	// A custom title for the item; defaults to the job title
	title?: string,

	// A custom subtitle for the item; defaults to the job owner
	subtitle?: string,
}>();

const icons = {
	location: mdiMapMarkerOutline,
	date: mdiCalendarRange,
	next: nextIcon,
};

const thumbnail = computed(() => {
	if (props.job.image) {
		return props.job.image;
	}
	if (props.job.event) {
		return getEventAvatarThumbnail(props.job.event);
	}

	return props.job.club ? props.job.club.avatar_thumbnail : null;
});

const toLink = computed(() => {
	if (props.to) {
		return props.to;
	}
	if (props.job.event) {
		return $spoferanUrl(`/jobs/events/${props.job.event._key}/${props.job._key}`);
	}
	if (props.job.club) {
		return ['company', 'fitness_club', 'sports_organizer', 'travel_organizer', 'school'].includes(props.job.club.presentation_type) ? $spoferanUrl(`/jobs/companies/${props.job.club._key}/${props.job._key}`) : $spoferanUrl(`/jobs/clubs/${props.job.club._key}/${props.job._key}`);
	}

	return null;
});

</script>